import axios from 'axios';
import {API_BASE_URL1 } from "../Services/baseApiUrl"
import axiosInstance from '../../Hooks/axoisInstance';

const getToken = () => {
    return localStorage.getItem("token");
}

export const getAllContainerMaster = async () => {
    try {
        const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetAllContainers`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            },
        );
        return response;

    } catch (error) {
        throw error

    }
}

export const createContainerMaster = async (conatinerData) => {
    try {
        const response = await axiosInstance.post(API_BASE_URL1 + `MasterCreate/AddNewContainer`, conatinerData,
            // const response = await axios.post(API_BASE_URL + `container/create`, conatinerData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${getToken()}`
                },

            });
        // console.log("response", response);
        return response;
    } catch (error) {
        throw error

    }
};

export const updateContainerMaster = async (id, requestData) => {
    try {
        const response = await axiosInstance.put(API_BASE_URL1 + `MasterCreate/UpdateContainerDetails`, requestData,
            // const response = await axios.post(API_BASE_URL + `container/update`, requestData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${getToken()}`
                },

            });

        return response;
    } catch (error) {
        throw error

    }
};

export const getContainerById = async (id) => {
    try {
        const response = await axiosInstance.get(API_BASE_URL1 + `container/getById/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                },

            });
        // console.log(response, 'response')
        return response;
    } catch (error) {
        throw error

    }
};

export const GetAllContainerCapacity = async () => {
    try {
        const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetAllContainerCapacity`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            },
        );
        return response;

    } catch (error) {
        throw error

    }
}

export const GetAllContainerType = async () => {
    try {
        const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetAllContainerType`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            },
        );
        return response;

    } catch (error) {
        throw error

    }
}